export default () => ({
    root: {
        marginLeft: 250
    },
    thumbnail: {
        width: 100,
        height: 100
    }
})